import ReactDOM from "react-dom/client";

// redux
import { Provider } from "react-redux";
import store from "./redux/store";

import Wrap from "./wrap";
import App from "./App";
import CreatRoute from "./routes";

let target = document.getElementById("root");
target.setAttribute("notranslate", true);
const root = ReactDOM.createRoot(target);
root.render(
  <Provider store={store}>
    <Wrap>
      <App />
      <CreatRoute />
    </Wrap>
  </Provider>
);
